import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{   updateBillingAddress: boolean; }>;

export const DispatchSetBillingAAddressUpdated: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutShipping/SetBillingAddressUpdate",
        updateBillingAddress: props.parameter.updateBillingAddress,
    });
};

export const chain = [DispatchSetBillingAAddressUpdated];

const setBillingAddressUpdate = createHandlerChainRunner(chain, "SetBillingAddressUpdate");
export default setBillingAddressUpdate;